import Chart from 'chart.js';

export default class ChartUtil {
  /**
   * Parses the sector lablels
   * parses the sector datasets
   * @param lablels
   * @param datasets
   */
  public static planetChartData(labels: [], data: []) {
    const config = {
      type: 'doughnut',
      data: {
        labels,
        datasets: [
          {
            data,
          },
        ],
      },
    };
    return config;
  }

  public static generateChartData(labels: any[], datasets: any[]) {
    const config = {
      type: 'doughnut',
      data: {
        labels,
        datasets,
      },
      options: {
        legend: {
          display: false,
        },
        layout: {
          padding: {
            right: 0,
          },
        },
        tooltips: {
          enabled: false,
        },
        plugins: {
          datalabels: {
            color: 'white',
            formatter: (value: any, cht: any) => {
              let sum = 0;
              const dataArr = cht.chart.data.datasets[0].data;
              dataArr.map((el: any) => {
                sum += el;
                return null;
              });
              const val = Math.round(((value * 100) / sum));
              if (val > 0) {
                const percentage = `${val}%`;
                return percentage;
              }
              const percentage = '';
              return percentage;
            },
            font: {
              weight: 600,
            },
          },
        },
        legendCallback(cht: any) {
          const text = [];
          const ds = cht.data?.datasets[0];
          if (ds.data.length > 0) {
            const ul = '<ul class="0-legend">';
            const ulComplete = '</ul>';
            const li = '<li>';
            const liComplete = '</li>';
            text.push(ul);
            const sum = ds.data.reduce((a: any, b: any) => a + b);
            for (let i = 0; i < ds.data.length; i += 1) {
              text.push(li);
              const perc = Math.round(((100 * ds.data[i]) / sum));
              const label = `<span style="background-color:
                ${ds.backgroundColor[i]}"><p>${cht.data.labels[i]}</p></span>`;
              text.push(label);
              const percentage = `<span class="percentage">${perc}%</span>`;
              text.push(percentage);
              text.push(liComplete);
            }
            text.push(ulComplete);
          }
          return text.join('');
        },
      },
    };
    return config;
  }

  public static getChartAnimation(noDataContainer: any, legendContainer: any) {
    return {
      onComplete: (animation: any) => {
        const canvasContainer = (document
          .getElementById(animation.chart.canvas.id) as HTMLElement);
        const firstSet = animation.chart.config.data?.datasets[0].data;
        const dataSum = firstSet.length > 0 ? firstSet
          .reduce((accumulator: any, currentValue: any) => accumulator + currentValue) : 0;
        if (typeof firstSet !== 'object' || dataSum === 0) {
          // eslint-disable-next-line no-param-reassign
          noDataContainer.style.display = 'block';
          canvasContainer.style.display = 'none';
          // eslint-disable-next-line no-param-reassign
          legendContainer.style.display = 'none';
        } else {
          // eslint-disable-next-line no-param-reassign
          noDataContainer.style.display = 'none';
          canvasContainer.style.display = 'block';
          // eslint-disable-next-line no-param-reassign
          legendContainer.style.display = 'block';
        }
      },
    };
  }
}
